import { createAction, props } from '@ngrx/store';

/***** Load Virtual Event Summary: BEGIN *****/
export const loadVirtualEventSummary = createAction(
  '[VirtualEvent] Load VirtualEventSummary'
);

export const loadVirtualEventSummarySuccess = createAction(
  '[VirtualEvent] Load VirtualEventSummary Success',
  props<{ data: any }>()
);

export const loadVirtualEventSummaryFailure = createAction(
  '[VirtualEvent] Load VirtualEventSummary Failure',
  props<{ error: any }>()
);
/***** Load Virtual Event Summary: END *****/

export const updateVirtualEventSummary = createAction(
  '[VirtualEvent] Update VirtualEventSummary',
  props<any>()
);


export const clearVirtualEventSummary = createAction(
  '[VirtualEvent] Clear VirtualEventSummary',
  props<any>()
);
